import { Platform } from "../constants";

import { ConstructDestinationUrl, URLVerification } from "./components/utms";
import { type PlatformDetails } from "./platform-details";
import { UtmSpendAdditionalDetails } from "./utm-spend-details";

const PLATFORM = Platform.STACK_ADAPT;

export const StackAdaptDetails: PlatformDetails = {
  northbeamDocUrl: "",
  officialDocUrl: "",
  additionalDetails: UtmSpendAdditionalDetails(PLATFORM),
};

export const StackAdaptSetup = () => (
  <>
    <ConstructDestinationUrl platform={PLATFORM} />
    <URLVerification platform={PLATFORM} />
  </>
);
